document.addEventListener("DOMContentLoaded", function() {
    const desktopFooterTit = document.querySelector('#footer .footer_tit');
    const mobileFooterHeadTit = document.querySelector('#mobile_footer .footer_head_tit');
    const mobileFooterBodyTit = document.querySelector('#mobile_footer .footer_body_tit');

    const desktopFooterLayout = document.querySelector('#footer');
    const mobileFooterLayout = document.querySelector('#mobile_footer');

    const desktopFooterBottom = document.querySelector('#footer .footer_bottom');
    const mobileFooterHeadBottom = document.querySelector('#mobile_footer .footer_head_bottom');
    const mobileFooterBodyBottom = document.querySelector('#mobile_footer .footer_body_bottom');


    desktopFooterLayout.classList.add('close');
    desktopFooterBottom.style.display = 'none';

    mobileFooterLayout.classList.add('close');
    mobileFooterHeadBottom.style.display = 'none';
    mobileFooterBodyBottom.style.display = 'none';


    desktopFooterTit.addEventListener('click', function() {
        const isOpen = desktopFooterBottom.style.display === 'none';
        if (isOpen) {
            desktopFooterLayout.classList.remove('close');
            desktopFooterBottom.style.display = 'flex';
            desktopFooterBottom.scrollIntoView({ behavior: 'smooth' });
            desktopFooterTit.classList.add('active');
        } else {
            desktopFooterLayout.classList.add('close');
            desktopFooterBottom.style.display = 'none';
            desktopFooterTit.classList.remove('active');
        }
    });


    mobileFooterHeadTit.addEventListener('click', function() {
        const isOpen = mobileFooterHeadBottom.style.display === 'none';
        if (isOpen) {
            mobileFooterLayout.classList.remove('close');
            mobileFooterHeadBottom.style.display = 'block';
            mobileFooterHeadBottom.scrollIntoView({ behavior: 'smooth' });
            mobileFooterHeadTit.classList.add('active');
        } else {
            mobileFooterLayout.classList.add('close');
            mobileFooterHeadBottom.style.display = 'none';
            mobileFooterHeadTit.classList.remove('active');
        }
    });


    mobileFooterBodyTit.addEventListener('click', function() {
        const isOpen = mobileFooterBodyBottom.style.display === 'none';
        if (isOpen) {
            mobileFooterLayout.classList.remove('close');
            mobileFooterBodyBottom.style.display = 'block';
            mobileFooterBodyBottom.scrollIntoView({ behavior: 'smooth' });
            mobileFooterBodyTit.classList.add('active');
        } else {
            mobileFooterLayout.classList.add('close');
            mobileFooterBodyBottom.style.display = 'none';
            mobileFooterBodyTit.classList.remove('active');
        }
    });
});
